import React, { FC, ComponentProps } from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';

type Props = ComponentProps<typeof Button> & { label?: string };

const ButtonNewRecord: FC<Props> = (props) => (
  <Button
    {...props}
    className={props.label ? 'rounded-pill' : 'btn-circle'}
    variant="primary"
    onClick={props.onClick}
    data-toggle="tooltip"
    data-placement="left"
    title="Νέα Εγγραφή"
  >
    <FaPlus className={`mb-1 ${props.label ? 'me-2' : ''}`} />
    {props.label}
    {/* {console.log('$$$ label', props.label)} */}
  </Button>
);

export default React.memo(ButtonNewRecord);
